import { createAction } from '@reduxjs/toolkit'

export const setModalConnect = createAction<any>('market/setModalConnect')
export const setModalBuyNow = createAction<any>('market/setModalBuyNow')
